<div id="navigationMenu">
  <div id="capNavItemsWidth">
    @for (link of navItem?.links; track link) {
      <button mat-button class="navItem" [routerLink]="navItem.linkPrefix + link.urlSlug">{{ link.name }}</button>
    }
  </div>
</div>
